export const languages = [
  {
    label: 'language.polish',
    code: 'pl',
    flag: 'pl',
  },
  {
    label: 'language.english',
    code: 'en',
    flag: 'gb',
  },
];
